import * as React from 'react';
import c from 'classnames';
import styles from './ScrollToTop.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export class ScrollToTopButton extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showing: false,
      prevScrollpos: 0,
    };
    this.onScroll = this.onScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll);
  }
  
  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    const currentScrollPos = window.pageYOffset;
    if (currentScrollPos > 150) {
      this.setState({ showing: true });
    } else {
      this.setState({ showing: false });
    }
    this.setState({ prevScrollpos: currentScrollPos });
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  render() {
    return (
      <div
        className={c(
          styles.totop, 
          { 
            [styles.active]: this.state.showing, 
            [styles.detailpage]: this.props.isDetailPage,
          },
        )}
        onClick={() => { this.scrollToTop(); }} >
        <FontAwesomeIcon icon={['fas', 'caret-square-up']} />
      </div>
    );
  }
}
